<template>
  <div class="modal sign-modal">
    <div class="overlay" @click="$emit('closeSignUpModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeSignUpModal')" src="./../img/close.svg"/>
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <div class="form-fields register-content">
              <form @submit.prevent="submitRegister" class="form-fields-wrapper">
                <div class="title">{{ $t(`Registration`) }}</div>
                <label>
                  <input type="text" :placeholder="'*' + $t('First name')" v-model="name" @keydown="allowOnlyLetters"/>
                </label>
                <label>
                  <input type="text" :placeholder="'*' + $t('Last Name')" v-model="surname"
                         @keydown="allowOnlyLetters"/>
                </label>
                <label>
                  <input type="email" :placeholder="'*' + $t('Email')" v-model="email"/>
                </label>
                <label class="phone-number-wrapper" v-if="countryOptionsIso.length">
                  <VuePhoneNumberInput
                      required
                      v-model="phone"
                      :only-countries="countryOptionsIso"
                      :default-country-code="defaultCountryIso"
                      @update="phoneDataUpdate($event)"
                      :translations="phoneInputTranslations"
                  />
                </label>
                <label>
                  <input type="password" :placeholder="'*' + $t('Password')" v-model="pass"/>
                </label>
                <label>
                  <input type="password" :placeholder="'*' + $t('Confirm Password')" v-model="passConfirm"/>
                </label>
                <label>
                  <input type="text" :placeholder="$t('Address')" v-model="address"/>
                </label>
                <label>
                  <input type="text" :placeholder="$t('City')" v-model="city"/>
                </label>
                <label>
                  <input type="text" :placeholder="$t('Post Code')" v-model="postCode"/>
                </label>
                <label>
                  <select v-model="country" :class="{ 'select-placeholder-text': !country }">
                    <option selected value="">{{ $t(`Country`) }}</option>
                    <option v-for="item in countryOptions" :value="item" :key="item.iso">{{ item.name }}</option>
                  </select>
                </label>
                <label>
                  <input type="text" :placeholder="$t('Referral code')" v-model="referralCode"/>
                </label>

                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms"/>
                        <div class="checkbox"></div>
                        <span class="title">{{ $t(`I agree with`) }}</span>
                        <a @click="goToPage('privacy')" class="title"> {{ $t(`privacy policy`) }} </a>
                        <span class="title">{{ $t(`and`) }}</span>
                        <a @click="goToPage('terms')" class="title"> {{ $t(`terms and conditions`) }}</a>
                      </div>
                    </label>
                  </div>
                  <button :class="['button', { 'disabled': !requiredRegisterFieldsAreFilled }]" type="submit">
                    <span>{{ $t(`SIGN UP`) }}</span>
                  </button>
                </div>

                <transition name="slide">
                  <div v-if="error" class="error-desc desc red">{{ error }}</div>
                </transition>

                <div class="modal-bottom">
                  <div class="desc">{{ $t(`Have account?`) }}</div>
                  <div class="link switch-register" @click="$emit('openSignInModal')">{{ $t(`Login`) }}</div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import VuePhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import {filterPhoneCountries} from '@/utils/filterPhoneCountries'

export default defineComponent({
  name: 'SignUpModal',
  emits: ['closeSignUpModal', 'openSignInModal', 'closeSignInModal', 'registration'],
  inject: ['error', 'openSignInModal', 'goToPage'],
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      email: '',
      pass: '',
      name: '',
      surname: '',
      phone: '',
      phoneFull: '',
      passConfirm: '',
      terms: false,
      countryOptionsIso: [],
      countryOptions: [],
      country: '',
      countryId: '',
      city: '',
      address: '',
      postCode: '',
      referralCode: '',
      phoneInputTranslations: {
        countrySelector: {
          placeholder: 'Country code',
          error: 'Choose country',
          searchPlaceholder: 'Search a country',
        },
        phoneInput: {
          placeholder: '* Phone number',
          example: 'Example:',
        },
      }
    }
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      return !!(this.name && this.surname && this.phone && this.email && this.pass && this.passConfirm && this.terms)
    },
    defaultCountryIso() {
      return this.countryOptionsIso?.length ? this.countryOptionsIso[0] : null
    }
  },
  mounted() {
    this.getCountries()
  },
  methods: {
    getCountries() {
      this.$http.get('countries')
          .then(res => {
            const allCountries = res.data.payload

            // Полный список для селекта
            this.countryOptions = allCountries

            // Отфильтрованные ISO коды только для phone input
            this.countryOptionsIso = filterPhoneCountries(allCountries).filtered.map(({iso2}) => iso2)
          })
          .catch(err => {
            if (err.response?.status === 401) {
              this.openSignInModal()
            }
          })
    },
    getDefaultCountryIso() {
      return this.countryOptionsIso[0] || null
    },
    phoneDataUpdate(e) {
      this.phoneFull = e.number || this.phone
    },
    allowOnlyLetters(e) {
      if (/\d/.test(e.key)) e.preventDefault()
    },
    submitRegister() {
      const regData = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phoneFull,
        password: this.pass,
        passConfirm: this.passConfirm,
        address: this.address,
        post_code: this.postCode,
        city: this.city,
        country_id: this.country.id,
        referral_code: this.referralCode,
      }
      this.$emit('registration', regData)
    }
  }
})
</script>

